module.exports = __webpack_public_path__ + "static/AvenirLTStd-BlackOblique-bd4030bec344bc56ee83fe8e80fa3069.woff";